// No delete mutation: the Angular source has no delete UI/endpoint for designations.
export const INSERT_DESIGNATION_MUTATION = `
  mutation InsertDesignation($input: DesignationInsertInput!) {
    insertDesignation(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_DESIGNATION_MUTATION = `
  mutation UpdateDesignation($filter: String!, $input: DesignationUpdateInput!) {
    updateDesignation(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;
